import Service 							from "./../../Libs/Service";

import { Server } 						from "./Server";
import _ from "lodash";

let Order = new Service({

	Name: "Order",

	Libraries: [],

	Events: {
	},

	Actions: {

		"CreateNewOrderCompleted": function (result) {
			if (result.success) {
				Broadcast.call('New Order Created');
			} else if (result.error) {
				Broadcast.call('New Order Created', [result.error]);
			}
		},

		"CreateNewCampaignCompleted": function (result) {
			if (result.success) {
				Broadcast.call('New Campaign Created', [false, result.campaign]);
			} else if (result.error) {
				Broadcast.call('New Campaign Created', [result.error]);
			}
		},

		"CanDeleteOrder": function (result) {
			Broadcast.call("Can Delete Order", [result.error, result.success, result.orderId]);
		},

		"DeleteOrderCompleted": function (result) {
			Broadcast.call("Delete Order Completed", [result.error, result.success, result.orderId]);
		},

		"DeleteCampaignCompleted": function (result) {
			Broadcast.call("Delete Campaign Completed", [result.error, result.success, result.campaignId]);
		},

		"CanDeleteCampaign": function (result) {
			Broadcast.call("Can Delete Campaign", [result.error, result.success, result.campaignId]);
		},

		"EditOrderCompleted": function (result) {
			if (result.success) {
				Broadcast.call('Edit Order Completed');
			} else if (result.error) {
				Broadcast.call('Edit Order Completed', [result.error]);
			}
		},

		"EditCampaignCompleted": function (result) {
			if (result.success) {
				Broadcast.call('Edit Campaign Completed');
			} else if (result.error) {
				Broadcast.call('Edit Campaign Completed', [result.error]);
			}
		},

		"Orders": function (orders) {

			this.updateOrders(orders);

			Broadcast.call("Orders Loaded");

		},

		"Campaigns": function (campaigns) {

			this.updateCampaigns(campaigns);

			Broadcast.call("Campaigns Loaded");

		},


	},

	init() {
		this.Orders = {};
		this.Campaigns = {};
		this.CampaignsByOrder = {};
	},

	updateOrders(orders) {

		_.each(orders, (order, orderId) => {

			if (!order) {

				let oldOrder = this.Orders[orderId];

				if (oldOrder) delete this.Orders[orderId];

				let oldOrderInOrdersWithImpressions = TrackingEvent.OrdersWithImpressions[orderId];

				if (oldOrderInOrdersWithImpressions) delete TrackingEvent.OrdersWithImpressions[orderId];

			} else {

				this.Orders[order.id] = order;

				TrackingEvent.setOrderWithImpressions(order);

				if (this.CampaignsByOrder[order.id]) {

					Object.keys(this.CampaignsByOrder[order.id]).forEach(campaignId => {

						TrackingEvent.CampaignsWithEvents[campaignId].active = order.active;
						TrackingEvent.CampaignsWithEvents[campaignId].order_name = order.name;

					});

				}

			}

		});

	},

	updateCampaigns(campaigns) {

		_.each(campaigns, (campaign, campaignId) => {

			if (!campaign) {

				let oldCampaign = this.Campaigns[campaignId];
				if (oldCampaign) {

					let orderId = oldCampaign.order_id;
					if (orderId && this.CampaignsByOrder[orderId] && this.CampaignsByOrder[orderId][campaignId]) {

						delete this.CampaignsByOrder[orderId][campaignId];
						if (!Object.keys(this.CampaignsByOrder[orderId]).length) delete this.CampaignsByOrder[orderId];

					}

					delete this.Campaigns[campaignId];
				}

				let oldCampaignInCampaignsWithEvents = TrackingEvent.CampaignsWithEvents[campaignId];
				if (oldCampaignInCampaignsWithEvents) delete TrackingEvent.CampaignsWithEvents[campaignId];


			} else {

				this.Campaigns[campaign.id] = campaign;

				if (!this.CampaignsByOrder[campaign.order_id]) this.CampaignsByOrder[campaign.order_id] = {};
				this.CampaignsByOrder[campaign.order_id][campaign.id] = campaign;

				TrackingEvent.setCampaignWithEvents(campaign);

			}

		});

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Order) Order = window.Order;
else window.Order = Order;

export { Order }
